import { useEffect, useState } from 'react';
import { getUnixTime, fromUnixTime } from 'date-fns';
import useEventSessions from './useEventSessions';

const areSessionDatesBeforeEventStartDate = (event, eventSessions) => {
    if (!event) return false;
    if (!event?.meeting_start_time) return false;
    const { meeting_start_time: eventStartTime } = event;

    if (!Array.isArray(eventSessions)) return false;
    if (!eventSessions.length) return false;
    if (!eventSessions[0]?.session_start_time) return false;
    const { session_start_time: firstSessionStartTimestamp } = eventSessions[0];

    const eventStartTimestamp = getUnixTime(eventStartTime);
    if (firstSessionStartTimestamp > eventStartTimestamp) return false;

    return true;
};

const useEventSessionsTabsStartDate = event => {
    const [eventSessionsTabsStartDate, setEventSessionsTabsStartDate] = useState(event?.meeting_start_time);
    const { eventSessions } = useEventSessions({
        filters: `content_type:session AND event.event_code:${event?.event_code}`,
    });

    useEffect(() => {
        if (areSessionDatesBeforeEventStartDate(event, eventSessions)) {
            setEventSessionsTabsStartDate(fromUnixTime(eventSessions[0].session_start_time));
        }
    }, [event, eventSessions]);

    return { eventSessionsTabsStartDate };
};

export default useEventSessionsTabsStartDate;
